/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

$(document).ready(function() {

  $(".moa_item_link_btn").on('click', function() {
    $("html").addClass("lock-all");
    $(this).closest(".moa_item_image_inr").siblings(".moa_modal_wrap").addClass('model-open');
  }); 
  $(".moa_modal_cls_btn, .moa_modal_bg-overlay").click(function(){
    $("html").removeClass("lock-all");
    $(".moa_modal_wrap").removeClass('model-open');
  });

  // js/helper/currency.js
  function formatMoney(cents, format = "") {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.themeVariables.settings.moneyFormat;
    function defaultTo(value2, defaultValue) {
      return value2 == null || value2 !== value2 ? defaultValue : value2;
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ",");
      decimal = defaultTo(decimal, ".");
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100).toFixed(precision);
      let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
      return dollarsAmount + centsAmount;
    }
    let value = "";
    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_space_separator":
        value = formatWithDelimiters(cents, 2, " ", ".");
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'", ".");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_no_decimals_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 0, "'");
        break;
    }
    if (formatString.indexOf("with_comma_separator") !== -1) {
      return formatString.replace(placeholderRegex, value);
    } else {
      return formatString.replace(placeholderRegex, value);
    }
  }
  var currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;

  document.addEventListener('cart:updated', function(event) {
    var cart = event.detail.cart; // Get the updated content of the cart    
    console.log(cart);
    $('[data-product-add-to-cart-button]').removeAttr('disabled');
    $('.stockerr_msg').remove();
    var addedqty = 0;
    var cnnnt = 0;
    $(cart.items).each(function(i,e){          
      if(e['product_type'] == 'Fabric Swatch'){
        cnnnt += 1;
        addedqty += e['quantity'];      
      }
    });
    if(cnnnt > 0){
     var restqty = 5 - addedqty;
     $('.product-form [name="quantity"]').attr('data-limit',restqty); 
     if(restqty == 0){       
       $('[data-product-add-to-cart-button],.product-item.hasfabricitem .product-item__cta,.floating_btn_custom').attr('disabled','disabled');
       if($('.product [data-product-add-to-cart-button]').length > 0){
        $('.product [data-product-add-to-cart-button]').closest('form').after('<p class="stockerr_msg">You have added max quantities</p>'); 
       }       
       $('.product-form [name="quantity"]').val(1);
     }else{
       $('.product-form [name="quantity"]').attr('data-limit',restqty);        
       $('[data-product-add-to-cart-button],.product-item.hasfabricitem .product-item__cta,.floating_btn_custom').removeAttr('disabled');
       $('.stockerr_msg').remove();
     }     
    } 

    if(cart.item_count == 0){
      if($('body').hasClass('template-collection-fashion-capsule-collection')){
        $('.capsule-itemlist-wp .sticky-btn-wp [data-stickyatc]').removeClass('hasforce');
        $('.capsule-itemlist-wp .sticky-btn-wp .weddingerror').hide();
      }
    }
    var hascapitem = false;
    $(cart.items).each(function(i,e){    
      if(e.properties['_capsule_item']){
        hascapitem = true;
      }
    });
    if(hascapitem){
      if($('body').hasClass('template-product')){
        $('.product .product-form:not(.capsule_product) [data-product-add-to-cart-button],product-sticky-form:not(.capsule_product) [data-product-add-to-cart-button]').addClass('weditem_hidden');
        $('.product .product-form:not(.capsule_product) .disabled_data, product-sticky-form:not(.capsule_product) .disabled_data').removeAttr('hidden');
      }
      if($('product-item .product-item__cta-wrapper:not(.hascapitem)').length > 0){
        $('product-item .product-item__cta-wrapper:not(.hascapitem)').attr('hidden', true);
      }
      $('product-item .product-item__cta-wrapper.hascapitem').removeAttr('hidden');
      if($('.pdp-tab-slct-optn-pro-list .product-item__cta:not(.hascapitem)').length > 0){
        $('.pdp-tab-slct-optn-pro-list .product-item__cta:not(.hascapitem)').attr('disabled', 'disabled');
      }
    }else{
      if(cart.item_count == 0){
        if($('body').hasClass('template-product')){
          $('.product [data-product-add-to-cart-button], product-sticky-form [data-product-add-to-cart-button]').removeClass('weditem_hidden');
          $('.product .disabled_data, product-sticky-form .disabled_data').attr('hidden', true);
        }
        $('product-item .product-item__cta-wrapper').removeAttr('hidden');  
        if($('.pdp-tab-slct-optn-pro-list .product-item__cta').length > 0){
          $('.pdp-tab-slct-optn-pro-list .product-item__cta').removeAttr('disabled');
        }
      }else{
        if($('body').hasClass('template-product')){
          $('.product .product-form:not(.capsule_product):not(.wedding_product) [data-product-add-to-cart-button],product-sticky-form:not(.capsule_product):not(.wedding_product) [data-product-add-to-cart-button]').removeClass('weditem_hidden');
          $('.product .product-form:not(.capsule_product):not(.wedding_product) .disabled_data, product-sticky-form:not(.capsule_product):not(.wedding_product) .disabled_data').attr('hidden', true);
        }
        $('product-item .product-item__cta-wrapper:not(.hascapitem)').removeAttr('hidden');  
        if($('.pdp-tab-slct-optn-pro-list .product-item__cta:not(.hascapitem)').length > 0){
          $('.pdp-tab-slct-optn-pro-list .product-item__cta:not(.hascapitem)').removeAttr('disabled');
        }
      }
      
    }
    
    
  });

  $('body').on('change','.size-chart-table-info .size-chart_toggle input[type="radio"]', function(){
    if($(this).closest('.size-chart_toggle').find('input[type="radio"]:checked').val() == 'inch'){
      $(this).closest('.size-chart--tables').find(".size-chart-table-inch .inch_value").each(function (index) {
        const value = $(this).attr('data-inch').trim();
        $(this).text(value);
      });
    }else{
      $(this).closest('.size-chart--tables').find(".size-chart-table-inch .inch_value").each(function (index) {
        const value = $(this).attr('data-inch').trim();
        if(value.indexOf('-') > -1){
          var splitedvalue = value.split('-');
          console.log(splitedvalue)
          var cmvalue = `${(splitedvalue[0] * 2.54).toFixed(0)}-${(splitedvalue[1] * 2.54).toFixed(0)}`;
          console.log(cmvalue)
          $(this).text(cmvalue); // Store converted CM values
        }else{
          $(this).text((value * 2.54).toFixed(0)); // Store converted CM values
        }
      });
    }
  });
  
  if($('.length_width_wp').length > 0){
   $('body').on('change','.length_width_wp #length', function(){    
      var selectedqty = $(this).find('option:selected').attr('data-qty');
      $('[name="properties[Length]"]').val(selectedqty);
      // let productPrices = document.querySelector("[data-product-price-list]");
      // if (!productPrices) {
      //   return;
      // }
      // console.log(selectedqty);
      // var currentprice = parseInt($('[data-product-price-list]').attr('data-currentprice')) * parseInt(selectedqty);
      // var currentcompprice = parseInt($('[data-product-price-list]').attr('data-currentcompprice')) * parseInt(selectedqty);
      // productPrices.innerHTML = "";
      // if (currentcompprice > currentprice) {
      //   productPrices.innerHTML += `<span class="price price--highlight price--large"><span class="visually-hidden">${window.themeVariables.strings.productSalePrice}</span>${formatMoney(currentprice, currencyFormat)}</span>`;
      //   productPrices.innerHTML += `<span class="price price--compare"><span class="visually-hidden">${window.themeVariables.strings.productRegularPrice}</span>${formatMoney(currentcompprice, currencyFormat)}</span>`;
      // } else {
      //   productPrices.innerHTML += `<span class="price price--large"><span class="visually-hidden">${window.themeVariables.strings.productSalePrice}</span>${formatMoney(currentprice, currencyFormat)}</span>`;
      // }
      // productPrices.innerHTML += `<span class="per_yard_text">per yard</span>`;
    }); 
  }  

  $('body').on('click','.additional_item .additional_atc', function(){
    var submitButtons = $(this);    
    submitButtons.attr("disabled", "disabled");
    submitButtons.attr("aria-busy", "true");
    var vid = $(this).attr('data-vpid');
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: vid,
      },
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        submitButtons.removeAttr("disabled");
        submitButtons.removeAttr("aria-busy");        
      },
      success: function(data){
        submitButtons.removeAttr("disabled");
        submitButtons.removeAttr("aria-busy");        
        fetch(`${window.themeVariables.routes.cartUrl}.js`).then(async (response2) => {
          const cartContent = await response2.json();
          document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
            bubbles: true,
            detail: {
              cart: cartContent
            }
          }));
          // cartContent["sections"] = responseJson["sections"];
          document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
            bubbles: true,
            detail: {
              cart: cartContent,
              openMiniCart: true
            }
          }));
          // document.getElementById('mini-cart').open = true;
        });
      }
    });
  });  

  $('body').on('click', '.promo-section .simple-video__button', function() {
    var video = $(this).closest('.promo-section').find('video').get(0); // Get native DOM element

    if (video.paused) {
      $(this).attr('aria-label','Pause video');
      video.play();
    } else if (video.ended) {
      console.log('⏹️ Video has ended');
    } else {
      $(this).attr('aria-label','Play video');
      video.pause();
    }
  });

    function scrollToSection(event) {
    var width = $(window).outerWidth();
    event.preventDefault();
    $(".product-tab-iner a").removeClass("active");
    $(this).addClass("active");
    var $section = $($(this).attr("href"));
    if(width>=999){
       $("html, body").animate(
        {
          scrollTop: $section.offset().top - 102,      
        },
        500
      ); 
    } else {
      $("html, body").animate(
        {
          scrollTop: $section.offset().top - 0,      
        },
        500
      );
    }   
  }
  $(".ptb_link").on("click", scrollToSection);

  //set cookie
  function setCookie(name, value, days) {
      var d = new Date;
      d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
      document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
  }
      
  $('body').on('click','.ctryModal-Content .stay_here_button', function(){
    $(".ctryModal-Content-overlay").removeClass('active');
    $(".ctryModal-Content").removeClass('active');
    $("body").removeClass('overflow-hidden');
    setCookie('redirectchoice',true,30);
  });

  $(window).scroll(function() {
    var scrollDistance = $(window).scrollTop() + 200;    
    $('.page-section').each(function(i) {
      if ($(this).position().top <= scrollDistance) {
        $('.product-tab-row a.active').removeClass('active');
        $('.product-tab-row a').eq(i).addClass('active');
      }
    });
  }).scroll();

  $('.section_accordion_button_heading').click(function(){
    $(this).toggleClass('active');
    $(this).next('.section_accordion_content').slideToggle();
  });

  $('.product-offer-header').click(function(){
   $(this).toggleClass('active');
   $(this).next().slideToggle();
  });
  $("body").on("click", ".product-offer-code-block", function () {
    var copy_text = $(this).find('.product-offer-copy-code');
    var text = $(this).find('.product-offer-code').text();
    var $temp = $("<input>");
      
    $("body").append($temp);
    $temp.val(text).select();
    document.execCommand("copy");
    $temp.remove();
    copy_text.html('Copied');
      
    setTimeout(function () {
      copy_text.html('Copy');
    }, 1000);
  });

  // GIFTING PRODUCT
  $('body').on('change','.gifting_product_content #input-checkbox-product', function(){
    var mainprice = parseInt($('.product__info [data-product-price-list]').attr('data-currentprice'));
    var compareprice = parseInt($('.product__info [data-product-price-list]').attr('data-currentcompprice'));
    var prddta = JSON.parse($('.gifting_product_content').find('#extra_product').html());
    var vprice = prddta.product.variants[0].price;   
    console.log('vprice',vprice);
    console.log('prddta',prddta);
    var pricehtml = "";
    if($(this).is(':checked')){
      if (compareprice > mainprice) {
        pricehtml += `<span class="price price--highlight price--large"><span class="visually-hidden">${window.themeVariables.strings.productSalePrice}</span>${formatMoney(mainprice + vprice, currencyFormat)}</span>`;
        pricehtml += `<span class="price price--compare"><span class="visually-hidden">${window.themeVariables.strings.productRegularPrice}</span>${formatMoney(compareprice + vprice, currencyFormat)}</span>`;
      } else {
          pricehtml += `<span class="price price--large"><span class="visually-hidden">${window.themeVariables.strings.productSalePrice}</span>${formatMoney(mainprice + vprice, currencyFormat)}</span>`;
        }
    }else{
      if (compareprice > mainprice) {
        pricehtml += `<span class="price price--highlight price--large"><span class="visually-hidden">${window.themeVariables.strings.productSalePrice}</span>${formatMoney(mainprice, currencyFormat)}</span>`;
        pricehtml += `<span class="price price--compare"><span class="visually-hidden">${window.themeVariables.strings.productRegularPrice}</span>${formatMoney(compareprice, currencyFormat)}</span></span>`;
      } else {
        pricehtml += `<span class="price price--large"><span class="visually-hidden">${window.themeVariables.strings.productSalePrice}</span>${formatMoney(mainprice, currencyFormat)}</span>`;
      }
    }
    $(this).closest('.product__info').find('[data-product-price-list]').html(pricehtml);
  })

  if($(".video-slideshow-inner").length > 0){
    $(".video-slideshow-inner").slick({
      dots: true,
      arrows: false,
      slidesToShow: 1,
      infinite: false,
      autoplay: true,
      autoplaySpeed: 5000,
      slidesToScroll: 1
    }); 
  }    

  if($(".customer-testimonial_wrap").length > 0){
    $(".customer-testimonial_wrap").slick({
      dots: true,
      arrows: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1
    }); 
  }

  $('.video-slider-video-blocks').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false
  });
  $('.video-slider-cover-images').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 740,
        settings: {
          slidesToShow: 1,
          arrows: false
        }
      }
    ]
  });

  if($(".testimonial-third-list").length > 0){
    $(".testimonial-third-list").slick({
      dots: false,
      arrows: true,
      slidesToShow: 4,
      infinite: false,
      autoplay: false,
      autoplaySpeed: 3000,    
      slidesToScroll: 1,
      prevArrow: '<svg focusable="false" width="15" height="12" class="slick-prev" viewBox="0 0 17 14"><path d="M0 7h15M9 1l6 6-6 6" stroke="currentColor" stroke-width="2" fill="none"></path></svg>',
      nextArrow: '<svg focusable="false" width="15" height="12" class="slick-next" viewBox="0 0 17 14"><path d="M0 7h15M9 1l6 6-6 6" stroke="currentColor" stroke-width="2" fill="none"></path></svg>',
      responsive: [
        {
          breakpoint: 999,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 740,
          settings: {
            slidesToShow: 1,
            arrows: false
          }
        }
      ]
    });
  }

  if($(".offline-product-images").length > 0){
   $(".offline-product-images").slick({
    dots: false,
    arrows: false,
    slidesToShow: 1,
    infinite: false,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToScroll: 1
  });  
  }  

  $('.video-slider-cover-videos').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 740,
        settings: {
          slidesToShow: 1,
          arrows: false,
          dots: true
        }
      }
    ]
  });

  if($(".opdps-slider").length > 0){  
    $(".opdps-slider").slick({
      dots: false,
      arrows: true,
      slidesToShow: 1,
      infinite: false,
      autoplay: false,
      autoplaySpeed: 3000,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 740,
          settings: {
            arrows: false
          }
        }
      ]
    });
  }

  if($(".custom-slideshow_items-list").length > 0){  
    $(".custom-slideshow_items-list").slick({
      dots: false,
      arrows: false,
      slidesToShow: 1,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 2000,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 740,
          settings: {
            arrows: false
          }
        }
      ]
    });
  }


  const $slider = $('.video-with-images-grid .promo-left-slider');

  $slider.slick({
    fade: true,
    cssEase: 'linear',
    autoplay: false,
    autoplaySpeed: 4000,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    swipe: true,
    infinite: true,
    swipeToSlide: true,
    adaptiveHeight: true,
    pauseOnHover: false
  });

  function handleSlideChange(currentSlide) {
    const $currentSlide = $slider.find('.slick-slide[data-slick-index="' + currentSlide + '"]');
    const isMobile = window.matchMedia('(max-width: 999px)').matches;
  
    // const $visibleVideoWrapper = $currentSlide.find('.slideshow__image-wrapper').filter(function () {
    //   const hasHiddenPocket = $(this).hasClass('hidden-lap-and-up');
    //   const hasHiddenLap = $(this).hasClass('hidden-pocket');
    //   return (isMobile && !hasHiddenLap) || (!isMobile && !hasHiddenPocket);
    // });
  
    // const $video = $visibleVideoWrapper.find('video');
    const $video = $currentSlide.find('video');
    const videoElement = $video.get(0);
  
    // const $dots = $('.slick-dots li');
    // $dots.find('button').css('animation', 'none');
  
    // Pause all other videos
    $slider.find('video').each(function () {
      this.pause();
      this.currentTime = 0;
    });
  
    // Check if this slide has a visible video
    if (videoElement) {
      $slider.slick('slickPause');
  
      videoElement.muted = true;
      videoElement.playsInline = true;
  
      const playVideo = () => {
        const duration = videoElement.duration || 4.5;
        // setDotAnimationDuration(duration);

        console.log(videoElement)
        videoElement
          .play()
          .then(() => {
            console.log('🎬 Video autoplay started');
          })
          .catch(err => {
            console.warn('⚠️ Video autoplay failed:', err);
            $slider.slick('slickPlay');
            // setDotAnimationDuration(4.5);
          });
      };
  
      if (videoElement.readyState >= 1) {
        playVideo(); // metadata is already available
      } else {
        videoElement.onloadedmetadata = playVideo; // wait for metadata
      }
  
      videoElement.onended = function () {
        console.log('🎥 Video ended');
        $slider.slick('slickNext');
        $slider.slick('slickPlay');
      };
    } else {
      // It's an image slide
      console.log('🖼️ No video. Start image autoplay');
      $slider.slick('slickPlay');
      // setDotAnimationDuration(4.5);
    }
  }


  // Initial check
  handleSlideChange(0);

  // On after slide change
  $slider.on('afterChange', function (event, slick, currentSlide) {
    handleSlideChange(currentSlide);
  });

  $('body').on('click','.video-slider-cover-image, .video-slider-cover-video', function(){
    $('html').addClass('no-scroll');
   $(this).closest('.video-slider-inner').find('.video-slider-video-wrap').addClass('active');
   let slideno = $(this).data('slide') - 1;
   $(this).closest('.video-slider-inner').find('.video-slider-video-blocks').slick('slickGoTo', slideno);

      const video = $(this).closest('.video-slider-inner').find('.video-slider-video-blocks .video-slider-video-block.slick-slide.slick-current.slick-active').find('video')[0];
      video.currentTime = 0;   // restart from beginning
      video.muted = false;
      video.play().catch(err => {
        console.log('Autoplay prevented:', err);
      });
 });

  $('.video-slider-video-blocks').on('init afterChange', function(event, slick, currentSlide){
    var current = currentSlide || 0;
    console.log('current',current);
    var slidevideo = $(this).find('.slick-slide[data-slick-index="' + (current) + '"] video')[0];
    slidevideo.play().catch(err => {
        console.log('Autoplay prevented:', err);
      });
    var prevVideo = $(this).find('.slick-slide[data-slick-index="' + (current - 1) + '"] video')[0];
    if (prevVideo) {
        prevVideo.pause();
        prevVideo.currentTime = 0;
    }
    var nextVideo = $(this).find('.slick-slide[data-slick-index="' + (current + 1) + '"] video')[0];
    if (nextVideo) {
        nextVideo.pause();
        nextVideo.currentTime = 0;
    }
 })

 $('body').on('click', '.video-slider-close-button', function (){
  console.log("11");
  $('.video-slider-video-wrap').removeClass('active');
  $('.video-slider-video-blocks .video-slider-video-block video').each(function() {
      this.pause();
      $('html').removeClass('no-scroll');
    });
 })


  $('body').on('click','.offline-product-designs-image', function(){
    console.log("11");
    $('body').addClass('offline-product-design-popup-open');
    $(this).closest('.offline-product-wrapper').find('.offline-product-design-popup-slider').addClass('active');
    var slideno = $(this).data('slide');
    $('.opdps-slider').slick('slickGoTo', slideno - 1);
  });
  $('body').on('click','.opdps-close-btn', function(){
    console.log("11");
    $('body').removeClass('offline-product-design-popup-open');
    $(this).closest('.offline-product-design-popup-slider').removeClass('active');
  });

  $('.template-collection-fashion-capsule-collection').on('click','.capsule-itemlist-wp .block-swatch-list input[type="radio"]', function(){
    console.log(this);
    var allselected = true;
    $('.capsule-itemlist-wp .product').each(function(i,e){
      if($(this).find('.block-swatch-list input[type="radio"]:checked').length == 0){
        allselected = false;
      }
    });
    console.log(allselected);
    if(allselected){
      $('[data-stickyatc]').removeAttr('disabled').text($('[data-stickyatc]').attr('data-text')).addClass('readytoadd');
    }else{
      $('[data-stickyatc]').attr('disabled','disabled').text('SELECT SIZES FOR ALL 9 PIECES').removeClass('readytoadd');
    }
  });

  $('body').on('click','[data-stickyatc]', function(){  
    var submitButtons = $(this);    
    submitButtons.attr("disabled", "disabled");
    submitButtons.attr("aria-busy", "true");
    var items = [];
    var randomId = Math.random().toString(36).substring(2, 12);
    $('.capsule-itemlist-wp .product').each(function(i,e){      
      items.push({
        quantity: 1,
        id: $(this).find('[name="id"]').val(),
        properties: {
          '_fcbundleid': randomId
        }
      });
    });
    console.log(items);
    var data = {items};    
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: JSON.stringify(data),  // "body" ni jagyae "data" lakhvu
      dataType: 'json',
      contentType: 'application/json',  // JSON data hoy to aa jaruri chhe
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);     
        submitButtons.after('<p class="add_err_msg">'+response.description+'</p>');
        submitButtons.removeAttr("disabled");
        submitButtons.removeAttr("aria-busy"); 
        setTimeout(function(){
          submitButtons.closest('.item_details').find('.add_err_msg').remove();
        },5000);
      },
      success: function(data){
        submitButtons.removeAttr("disabled");
        submitButtons.removeAttr("aria-busy");        
        fetch(`${window.themeVariables.routes.cartUrl}.js`).then(async (response2) => {
          const cartContent = await response2.json();
          document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
            bubbles: true,
            detail: {
              cart: cartContent
            }
          }));
          // cartContent["sections"] = responseJson["sections"];
          document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
            bubbles: true,
            detail: {
              cart: cartContent,
              openMiniCart: true
            }
          }));
          // document.getElementById('mini-cart').open = true;
        });
      }
    });    

  });

  $('body').on('click','.line-item__remove-button-custom', function(){
    var itemindexs = $(this).attr('data-itemindextoremove').split(',');
    var updateData = {};
    $(itemindexs).each(function(i,e){
      updateData[e] = 0;             
    });         
    console.log(updateData);
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: {
        updates: updateData
      },
      dataType: 'json',
      async:false,
      success: function(data) {   
        if (window.themeVariables.settings.pageType === "cart") {
          window.location.href = '/cart';
        }else{          
         $.getJSON('/cart.js', function(cart){
          document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
            bubbles: true,
            detail: {
              cart: cart
            }
          }));
          document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
            bubbles: true,
            detail: {
              cart: cart
            }
          }));        
        });  
       }
      },
      error: function (jqXHR, textStatus, errorThrown) {
        console.log(jqXHR);
      }
    });
  });

  $('body').on('click','.line-item__info .show_details', function(){
    console.log("11");
    if($(this).closest('.product-item-meta__property-list').find('.product-item-meta__property').is(':visible')){      
      $(this).closest('.product-item-meta__property-list').find('.product-item-meta__property').slideUp();
      $(this).text('View details');
    }else{
      $(this).closest('.product-item-meta__property-list').find('.product-item-meta__property').slideDown();
      $(this).text('Hide details');
    }    
  });

  $('a[href^="/collections/"],a[href^="https://dmoksha.com/collections/"]').each(function(){
    var oldUrl = $(this).attr("href"); // Get current url
     if(oldUrl.indexOf('?') > -1){
      // var url = oldUrl+'&filter.v.availability=1'; 
     }else{
      var url = oldUrl+'?filter.v.availability=1';
      var newUrl = oldUrl.replace(oldUrl, url); // Create new url
      $(this).attr("href", newUrl); // Set herf value
     }         
  });

  $('body').on('click','.rm-content-text',function(e) {
    e.preventDefault();
    // $(this).closest('collapsible-content').find('.collapsible__content').toggleClass('active');
    $(this).closest('collapsible-content').find('.hasmore').each(function() {
      $(this).slideToggle();
    });
    if ($(this).text() == "See more") {
      $(this).text("See less")
    } else {
      $(this).text("See more")
    }
    console.log("11");
  });

  document.addEventListener('variant:changed', function(event) {
    let variant = event.detail.variant; // Gives you access to the whole variant details
    let form = event.target;
    // if($(window).width() < 999){
    //  if(!$('.sticky-container').hasClass('formvisible')){
    //     $('.sticky-container').addClass('forceatc');
    //   } 
    //   if(variant['available']){
    //     $('.sticky-container').removeClass('hidden-pocket');
    //   }else{
    //     $('.sticky-container').addClass('hidden-pocket');
    //   }
    // }  
    
    var product_handle = $("body").attr("product-handle");
    $.get(`/products/${product_handle}?variant=${variant.id}`, function (data) {
      $(".product-form__shipping_text-wrapper").html(
        $(data).find(".product-form__shipping_text-wrapper").html()
      );
    });  
  });

  if($(window).width() > 1199){
    $('body').on('mouseenter','.recent_view_btn', function(){
      $('.recent_popup').addClass('active');
    });

    $('body').on('mouseleave','.recent_view_btn', function(){
      $('.recent_popup').removeClass('active');
    });
  }else{
    $('body').on('click','.recent_view_btn', function(){
      $('.recent_popup').addClass('active');
    });
    $('body').on('click','.recent_popup .modal__close-button', function(){
      console.log("11");
      $('.recent_popup').removeClass('active');
    });
  }
  
  document.addEventListener('recently_view:added', function(event) {
    console.log(event)
    if(event.detail.parent.classList.contains('header_recently_view') && $(window).width() > 1199){
      $('.header_recently_view .header_recently_view_slider').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        infinite: true,
        prevArrow: '<span class="rv_slider_arrows left_arrow"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" x="0" y="0" viewBox="0 0 240.823 240.823" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M57.633 129.007 165.93 237.268c4.752 4.74 12.451 4.74 17.215 0 4.752-4.74 4.752-12.439 0-17.179l-99.707-99.671 99.695-99.671c4.752-4.74 4.752-12.439 0-17.191-4.752-4.74-12.463-4.74-17.215 0L57.621 111.816c-4.679 4.691-4.679 12.511.012 17.191z" fill="#000000" opacity="1" data-original="#000000"></path></g></svg></span>',
        nextArrow: '<span class="rv_slider_arrows right_arrow"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" x="0" y="0" viewBox="0 0 240.823 240.823" style="enable-background:new 0 0 512 512" xml:space="preserve"><g><path d="M183.189 111.816 74.892 3.555c-4.752-4.74-12.451-4.74-17.215 0-4.752 4.74-4.752 12.439 0 17.179l99.707 99.671-99.695 99.671c-4.752 4.74-4.752 12.439 0 17.191 4.752 4.74 12.463 4.74 17.215 0l108.297-108.261c4.68-4.691 4.68-12.511-.012-17.19z" fill="#000000" opacity="1" data-original="#000000"></path></g></svg></span>',
        responsive: [
          {
            breakpoint: 999,
            settings: {
              slidesToShow: 3,
            }
          },
          {
            breakpoint: 740,
            settings: {
              slidesToShow: 1,
              arrows: false,
              dots: true
            }
          }
        ]
      });
    }
  });
  if($('.bestsellers_item_slider').length > 0 && $(window).width() > 1199){
    $('.bestsellers_item_slider').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      infinite: true,
      prevArrow: '<span class="rv_slider_arrows left_arrow"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" x="0" y="0" viewBox="0 0 240.823 240.823" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M57.633 129.007 165.93 237.268c4.752 4.74 12.451 4.74 17.215 0 4.752-4.74 4.752-12.439 0-17.179l-99.707-99.671 99.695-99.671c4.752-4.74 4.752-12.439 0-17.191-4.752-4.74-12.463-4.74-17.215 0L57.621 111.816c-4.679 4.691-4.679 12.511.012 17.191z" fill="#000000" opacity="1" data-original="#000000"></path></g></svg></span>',
      nextArrow: '<span class="rv_slider_arrows right_arrow"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" x="0" y="0" viewBox="0 0 240.823 240.823" style="enable-background:new 0 0 512 512" xml:space="preserve"><g><path d="M183.189 111.816 74.892 3.555c-4.752-4.74-12.451-4.74-17.215 0-4.752 4.74-4.752 12.439 0 17.179l99.707 99.671-99.695 99.671c-4.752 4.74-4.752 12.439 0 17.191 4.752 4.74 12.463 4.74 17.215 0l108.297-108.261c4.68-4.691 4.68-12.511-.012-17.19z" fill="#000000" opacity="1" data-original="#000000"></path></g></svg></span>',
      responsive: [
        {
          breakpoint: 999,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 740,
          settings: {
            slidesToShow: 1,
            arrows: false,
            dots: true
          }
        }
      ]
    });
  }

  $('body').on('click','.custom_filter_wp .checkbox-container input[type="checkbox"]',function(e){
    console.log("11");
    e.preventDefault();
    console.log('innn');
    var _this = $(this);
    var href = $(this).attr('name');
    var val = $(this).attr('value');
    if(val != undefined && val != ''){
      console.log('1111');
      if(val.indexOf(' ') >= 0){
        val = val.replaceAll(' ','+').replaceAll('&','%26');
      }
      if(val.indexOf('&') >= 0){
        val = val.replaceAll('&','%26');
      }
      var currentURL = window.location.href;
      var finalVAL = href+'='+val;
      var is_current = false;
      var without_cur = [];
      var params = {};
      var parser = document.createElement('a');
      parser.href = window.location.href;
      var query = parser.search.substring(1);
      var vars = query.split('&');
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');        
        if(encodeURI(href) == pair[0] && val == pair[1]){
          is_current = true;
        }else{
          if(_this.closest('.customfiler_mainwp').hasClass('single_value')){
            if(encodeURI(href) == pair[0]){
             without_cur.push(pair[0] + '=' + val);    
            }else{
             without_cur.push(pair[0] + '=' + pair[1]);    
            }
          }else{
           without_cur.push(pair[0] + '=' + pair[1]); 
          }          
        }
      }
      if(is_current){  
        console.log('3333');
        currentURL = (currentURL.indexOf('?') > -1) ? currentURL.split('?')[0] : currentURL;
        if(without_cur.length > 0){
          currentURL = currentURL + '?' +without_cur.join('&')
        }else{              
          currentURL = currentURL;
        }            
      }else{
        console.log('2222');
        if(_this.closest('.customfiler_mainwp').hasClass('single_value') && currentURL.indexOf(href) > -1){
          var newurl = [];
          currentURL = (currentURL.indexOf('?') > -1) ? currentURL.split('?')[0] : currentURL;
          for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split('=');        
            if(encodeURI(href) == pair[0]){
              newurl.push(finalVAL);
            }else{                
              newurl.push(pair[0] + '=' + pair[1]);                 
            }
          }
          if(currentURL.indexOf('?') >= 0){
            currentURL = currentURL + '&' + newurl.join('&');
          }else{
            currentURL = currentURL + '?' + newurl.join('&');
          }
        }else{
         if(currentURL.indexOf('?') >= 0){
            currentURL = currentURL + '&' + finalVAL;
          }else{
            currentURL = currentURL + '?' + finalVAL;
          }  
        }        
      }   
      console.log(currentURL);
      this.dispatchEvent(new CustomEvent("facet:criteria-changed", {
        bubbles: true,
        detail: {
          url: currentURL.toString()
        }
      }));
    }
  });

  $('body').on('click', '.header-customer-icon', function () {
    console.log("11");
    $('html').addClass('lock-all');
    $('#header-customer-drawer').attr('open','');
  })
  $('body').on('click', '.header-customer-drawer-overlay, .header-customer-drawer-close', function () {
    console.log("11");
    $('html').removeClass('lock-all');
    $('#header-customer-drawer').removeAttr('open','');
  })
  
})

if($('#mobile-facet-toolbar').length > 0){
  var mobilefacetbar = $('#mobile-facet-toolbar').offset().top;
  $(window).on('scroll', function() {
    if ($(this).scrollTop() > mobilefacetbar) {
      $('#mobile-facet-toolbar').addClass('fixed');
    } else {
      $('#mobile-facet-toolbar').removeClass('fixed');
    }
  });
}

// document.addEventListener('variant:changed', function(event) {
//   let variant = event.detail.variant; // Gives you access to the whole variant details
//   let form = event.target;
//   console.log(variant);
// });


function isPartiallyInView($el) {
  var elementTop = $el.offset().top;
  var elementBottom = elementTop + $el.outerHeight();
  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();

  // Returns true if any part of the element is visible
  return elementBottom > viewportTop && elementTop < viewportBottom;
}

function isFullyOutOfView($el) {
  var elementTop = $el.offset().top;
  var elementBottom = elementTop + $el.outerHeight();
  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();

  // Returns true if element is entirely above or below the viewport
  return elementBottom <= viewportTop || elementTop >= viewportBottom;
}

function counterFun() {
  var $counter = $('.homes-count');
  if (!$counter.length) return;

  if (isPartiallyInView($counter)) {
    $('.count-number').each(function () {
      var $this = $(this);
      var countTo = parseInt($this.attr('count-number'), 10);

      if (!$this.hasClass('counted')) {
        $this.addClass('counted');
        $({ countNum: 0 }).animate(
          { countNum: countTo },
          {
            duration: 2000,
            easing: 'swing',
            step: function () {
              $this.text(Math.floor(this.countNum));
            },
            complete: function () {
              $this.text(countTo);
            }
          }
        );
      }
    });
  } else if (isFullyOutOfView($counter)) {
    // Reset only when fully out of view
    $('.count-number').each(function () {
      $(this).removeClass('counted').text('0');
    });
  }
}
$(window).on('scroll resize', counterFun);
$(document).ready(counterFun);

$(document).ready(function () {
  var placeholderTexts = window.themeVariables.settings.search_placeholder.split(', ');
  var currentIndex = 0;
  var currentChar = 0;
  var isDeleting = false;

  function typePlaceholder() {
    var currentText = placeholderTexts[currentIndex];
    var placeholder = currentText.substring(0, currentChar);

    $('.predictive-search__placeholder-input').attr('placeholder', placeholder + (isDeleting ? '' : ' '));

    if (!isDeleting && currentChar < currentText.length) {
      currentChar++;
      setTimeout(typePlaceholder, 100);
    } else if (!isDeleting) {
      isDeleting = true;
      setTimeout(typePlaceholder, 1000); // Wait before deleting
    } else if (isDeleting && currentChar > 0) {
      currentChar--;
      setTimeout(typePlaceholder, 50);
    } else {
      isDeleting = false;
      currentIndex = (currentIndex + 1) % placeholderTexts.length;
      setTimeout(typePlaceholder, 500);
    }
  }

  if(window.themeVariables.settings.search_placeholder.length > 0){
    typePlaceholder();
  }
});


if($('#AddToCart').length > 0){
  
  $(window).scroll(function(){     
    var elestop = $('#AddToCart').offset().top;
    var viewportTop = $(window).scrollTop();
    if (viewportTop >= elestop && elestop != 0) {
      $('.sticky-container').addClass('fixed');
    }else {
      $('.sticky-container').removeClass('fixed');
    }
  });  
}

$(window).on('scroll', function () {
  if ($(this).scrollTop() > 50) {
    $('body').addClass('scrolled');
  } else {
    $('body').removeClass('scrolled');
  }
});

document.addEventListener("DOMContentLoaded", () => {

  $('body').on('change','.autopaste_boxOuterCS input[type="checkbox"]', function(){
    if($(this).is(':checked')){
      $(this).closest('form').find('.altnumberOuterCS input').val($(this).closest('form').find('.mainnumberOuterCS input[type="text"]').val()).attr('readonly',true);
    }else{
      $(this).closest('form').find('.altnumberOuterCS input').val('').removeAttr('readonly');
    }
  });

  $('body').on('keyup','.mainnumberOuterCS input', function(){
    if($('.autopaste_boxOuterCS input[type="checkbox"]').is(':checked')){
      $(this).closest('form').find('.altnumberOuterCS input').val($(this).val()).attr('readonly',true);
    }else{
      $(this).closest('form').find('.altnumberOuterCS input').val('');
    }
  });

});
